import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Plots.css'; // Reusing Plots styles for consistent grid layout

import { supabase } from '../supabaseClient';


export default function FarmLands() {
  const navigate = useNavigate();
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const fetchFarmlands = async () => {
      setLoading(true);
      const { data } = await supabase.from('properties').select('*').eq('category', 'farmlands');
      if (data) setProperties(data);
      setLoading(false);
    };
    fetchFarmlands();
  }, []);

  return (
    <div className="plots-page">
      {/* Page Header */}
      <section className="page-header animate-fade-in-up">
        <div className="container text-center">
          <span className="section-tag" style={{ backgroundColor: 'var(--color-secondary-light)', color: 'var(--color-secondary)' }}>
            Agriculture & Lifestyle
          </span>
          <h1 className="page-title">Premium Farm Lands</h1>
          <p className="page-subtitle">
            Invest in nature with our premium, secure, and fertile farm lands. Perfect for organic farming, weekend getaways, or secure investments.
          </p>
        </div>
      </section>

      {/* Grid List */}
      <section className="plots-grid-section">
        <div className="container">
          <div className="grid-3" style={{ alignItems: 'stretch' }}>
            {loading ? (
              <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px 0' }}>
                <h3 style={{ color: 'var(--text-secondary)' }}>Loading...</h3>
              </div>
            ) : properties.length === 0 ? (
              <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px 0' }}>
                <h3 style={{ color: 'var(--text-secondary)' }}>No farm lands found.</h3>
              </div>
            ) : properties.map((plot) => (
              <div key={plot.id} className="premium-card plot-card flex-column" onClick={() => setSelectedPlot(plot)} style={{ cursor: 'pointer' }}>
                <div className="plot-card-image-container">
                  <img src={plot.image_url || plot.image} alt={plot.title} className="plot-card-image" />
                  <div className="plot-card-badges">
                    <span className="approval-badge">✓ {plot.approval}</span>
                    <span className={`status-badge status-plots`} style={plot.status === "Ready to Move In" ? { backgroundColor: '#ffca28', color: '#333', fontWeight: 'bold', textShadow: 'none' } : {}}>
                      {plot.status}
                    </span>
                  </div>
                </div>

                <div className="plot-card-body">
                  <h2 className="plot-title">{plot.title}</h2>
                  <p className="plot-location">📍 {plot.location}</p>

                  <div className="plot-specs">
                    <div className="spec-item">
                      <span className="spec-label">Plot Sizes</span>
                      <span className="spec-val font-bold">{plot.sizes}</span>
                    </div>
                    <div className="spec-item">
                      <span className="spec-label">Price Guide</span>
                      <span className="spec-val highlight-val">{plot.price}</span>
                    </div>
                  </div>

                  <div className="plot-card-footer" style={{ marginTop: 'auto', paddingTop: '15px' }}>
                    <button
                      className="btn btn-primary w-full"
                      style={{ marginBottom: '8px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedPlot(plot);
                      }}
                    >
                      View Complete Info
                    </button>
                    <button
                      className="btn btn-secondary w-full"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.localStorage.setItem('enquiry_subject', `Enquiry about farm lands at ${plot.title}`);
                        navigate('/contact');
                      }}
                    >
                      Check Availability & Prices
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedPlot && (
        <div className="modal-overlay" onClick={() => setSelectedPlot(null)}>
          <div className="modal-content animate-fade-in-up" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedPlot(null)}>&times;</button>
            <img src={selectedPlot.image_url || selectedPlot.image} alt={selectedPlot.title} className="modal-image" />
            
            <div className="modal-body">
               <h2 className="modal-title">{selectedPlot.title}</h2>
               <p className="modal-tagline">{selectedPlot.tagline}</p>
              
               {selectedPlot.extendedDetails?.highlights?.length > 0 && (
                 <div className="modal-section">
                   <h3>Project Highlights</h3>
                   <ul>
                     {selectedPlot.extendedDetails.highlights.map((h, i) => <li key={i}>✓ {h}</li>)}
                   </ul>
                 </div>
               )}

               {selectedPlot.extendedDetails?.fullAmenities?.length > 0 && (
                 <div className="modal-section">
                   <h3>Amenities & Features</h3>
                   <ul className="grid-list">
                     {selectedPlot.extendedDetails.fullAmenities.map((a, i) => <li key={i}>▪ {a}</li>)}
                   </ul>
                 </div>
               )}

               {selectedPlot.extendedDetails?.extraInfo?.length > 0 && (
                 <div className="modal-section">
                   <h3>{selectedPlot.extendedDetails.extraInfoTitle}</h3>
                   <ul className="grid-list">
                     {selectedPlot.extendedDetails.extraInfo.map((l, i) => (
                       <li key={i}>{selectedPlot.extendedDetails.extraInfoIcon} {l}</li>
                     ))}
                   </ul>
                 </div>
               )}

              <div className="modal-footer text-center">
                 <button
                   className="btn btn-secondary w-full"
                   onClick={() => {
                     window.localStorage.setItem('enquiry_subject', `Enquiry about farm lands at ${selectedPlot.title}`);
                     setSelectedPlot(null);
                     navigate('/contact');
                   }}
                 >
                   Enquire Now
                 </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
